import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogRef } from '@angular/material/dialog';
import { MaterialModule } from '@huge-monorepo/shared/modules';
import { ToolsModule } from '@huge-monorepo/shared/tools';
import { TableHeader } from '@huge-monorepo/shared/interfaces';

@Component({
  selector: 'huge-monorepo-teltonika-execute-task-modal',
  standalone: true,
  imports: [CommonModule, MaterialModule, ToolsModule],
  templateUrl: './TeltonikaExecuteTaskModal.component.html',
  styleUrl: './TeltonikaExecuteTaskModal.component.scss',
})
export class TeltonikaExecuteTaskModalComponent {
  constructor(
    public dialogRef: MatDialogRef<TeltonikaExecuteTaskModalComponent>,
  ) { }

  selectedTask: any;

  tasksHeaders: TableHeader[] = [
    {
      ID: 'GroupName',
      Index: 1,
      Sort: 'GroupName',
      Sortable: false,
      Text: 'Task Group Name',
      Type: String,
      Align: 'left',
    },
    {
      ID: 'TaskName',
      Index: 2,
      Sort: 'TaskName',
      Sortable: false,
      Text: 'Task Name',
      Type: String,
      Align: 'left',
    },
  ];

  closeDialog(save: boolean): void {
    if (!save) {
      this.dialogRef.close({ TaskID: null });
      return;
    }

    this.dialogRef.close({
      TaskID: this.selectedTask[0].ID,
    });
  }

  taskSelected(task: any) {
    this.selectedTask = task;
  }
}
